import { Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { useEffect, useState } from 'react'
import TableCouponUse from 'src/views/couponuse/TableCouponUse'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import DialogCoupon from '../../views/coupon/DialogCoupon'

const CouponUseList = () => {
    const [reload, setReload] = useState(0)
    const [show, setShow] = useState(false)
    const [couponID, setCouponID] = useState(0)

    useEffect(() => {
        !show && setCouponID(0)
    }, [show])

    useEffect(() => {
        couponID > 0 && setShow(true)
    }, [couponID])

    return (
        <Page title="Coupon">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                    <Typography variant='h5' color='#666CFF'>
                        쿠폰 등록
                    </Typography>
                    }
                    subtitle={
                    <Typography variant='body2'>
                        고객이 사용한 쿠폰 등록리스트를 보여줍니다.
                    </Typography>
                    }
                />
                <Grid item xs={12}>        
                    <TableCouponUse reload={reload} setReload={setReload} setCouponID={setCouponID} />
                </Grid>
                <DialogCoupon show={show} setShow={setShow} reload={reload} setReload={setReload} couponID={couponID} />
            </Grid>
        </Page>
    )
}

export default CouponUseList